(function () {
  'use strict';
  var description = document.querySelector('[data-product-description]');
  var slot = document.querySelector('[data-size-guide-slot]');
  if (!description || !slot || slot.dataset.enhanced) return;
  slot.dataset.enhanced = 'true';
  var label = slot.dataset.guideLabel;
  function sizingHeading(text) { return /^(?:size|sizing)\s*(?:guide|chart)\b/i.test(text.trim()) && text.trim().length < 90 || /^(sizing|measurements)\s*[:.]?$/i.test(text.trim()); }
  function measurementText(text) { return /\d/.test(text) && (/\b(cm|inches?|chest|waist|height|length|width|xs|xxl|small|medium|large|years|pit|top|bottom)\b/i.test(text) || /^(XS|S|M|L|XL|XXL)\s*[.\-:–]?\s*\d/i.test(text.trim())); }
  var guides = Array.from(description.querySelectorAll('details')).filter(function (details) {
    var summary = details.querySelector('summary');
    return details.classList.contains('lif-size-guide') || summary && /siz(e|ing)\s*(guide|chart|information|table)|measurements/i.test(summary.textContent);
  });
  guides.filter(function (guide) { return !guides.some(function (other) { return other !== guide && other.contains(guide); }); }).forEach(function (guide) {
    guide.classList.add('lif-size-guide');
    guide.open = false;
    slot.appendChild(guide);
  });
  Array.from(description.querySelectorAll('h2,h3,h4,p')).forEach(function (heading) {
    if (!sizingHeading(heading.textContent)) return;
    var nodes = [];
    var next = heading.nextElementSibling;
    while (next && /^(P|UL|OL)$/.test(next.tagName) && measurementText(next.textContent)) {
      nodes.push(next);
      next = next.nextElementSibling;
    }
    if (!nodes.length) return;
    var guide = document.createElement('details');
    guide.className = 'lif-size-guide';
    var summary = document.createElement('summary');
    summary.textContent = heading.textContent.trim();
    guide.appendChild(summary);
    nodes.forEach(function (node) { guide.appendChild(node); });
    slot.appendChild(guide);
    heading.remove();
  });
  Array.from(description.querySelectorAll('p')).forEach(function (start) {
    if (!description.contains(start) || !/^(XS|S|M|L|XL|XXL|XXXL)\s*[-:–]?\s*pit\s*to\s*pit\s*\d/i.test(start.textContent.trim())) return;
    var nodes = [];
    var next = start;
    while (next && next.tagName === 'P' && /pit\s*to\s*pit|top\s*to\s*bottom/i.test(next.textContent) && /\d/.test(next.textContent)) { nodes.push(next); next = next.nextElementSibling; }
    if (nodes.length < 4) return;
    var guide = document.createElement('details');
    guide.className = 'lif-size-guide';
    var summary = document.createElement('summary'); summary.textContent = label; guide.appendChild(summary);
    nodes.forEach(function (node) { guide.appendChild(node); }); slot.appendChild(guide);
  });
  var tables = Array.from(description.querySelectorAll('table'));
  tables.forEach(function (table) {
    var preceding = table.previousElementSibling;
    if (!preceding && table.parentElement !== description) preceding = table.parentElement.previousElementSibling;
    var nearbyHeading = preceding && sizingHeading(preceding.textContent);
    var text = table.textContent;
    var sizeTable = nearbyHeading || /\b(size|sizes|sizing)\b/i.test(text) && /\b(chest|waist|height|length|width|cm|inches|age|years)\b/i.test(text);
    if (!sizeTable) return;
    var guide = slot.querySelector('.lif-size-guide');
    if (!guide) {
      guide = document.createElement('details');
      guide.className = 'lif-size-guide';
      var summary = document.createElement('summary');
      summary.textContent = label;
      guide.appendChild(summary);
      slot.appendChild(guide);
    }
    if (nearbyHeading) {
      var heading = document.createElement('p');
      heading.className = 'lif-size-table-title';
      heading.textContent = preceding.textContent;
      guide.appendChild(heading);
      preceding.remove();
    }
    guide.appendChild(table);
    if (table.parentElement === description && description.textContent.trim() === '') description.hidden = true;
  });
  var regions = [];
  Array.from(slot.querySelectorAll('.lif-size-guide')).forEach(function (guide) {
    if (guide.querySelector('table')) return;
    var paragraphs = Array.from(guide.children).filter(function (node) { return node.tagName === 'P'; });
    var rows = [];
    for (var i = 0; i < paragraphs.length - 1; i++) {
      var width = paragraphs[i].textContent.trim().match(/^(XS|S|M|L|XL|XXL|XXXL|X[ -]?Small|Small|Medium|Large|X[ -]?Large|XX[ -]?Large|\d+(?:\/\d+)?)\s*[-:–]?\s*pit\s*to\s*pit\s*(\d+(?:\.\d+)?\s*(?:cm|inches?))\s*$/i);
      var length = paragraphs[i + 1].textContent.trim().match(/^top\s*to\s*bottom\s*(\d+(?:\.\d+)?\s*(?:cm|inches?))\s*$/i);
      if (width && length) { rows.push({values: [width[1].toUpperCase(), width[2], length[1]], nodes: [paragraphs[i], paragraphs[i + 1]]}); i++; }
    }
    if (rows.length < 2) return;
    var table = document.createElement('table');
    var head = table.createTHead().insertRow();
    [slot.dataset.sizeLabel, slot.dataset.widthLabel, slot.dataset.lengthLabel].forEach(function (label) { var th = document.createElement('th'); th.scope = 'col'; th.textContent = label; head.appendChild(th); });
    var body = table.createTBody();
    rows.forEach(function (row) { var tr = body.insertRow(); row.values.forEach(function (value) { var td = tr.insertCell(); td.textContent = value; }); });
    rows[0].nodes[0].before(table);
    rows.forEach(function (row) { row.nodes.forEach(function (node) { node.remove(); }); });
  });
  Array.from(slot.querySelectorAll('.lif-size-guide')).forEach(function (guide) {
    if (guide.querySelector('table')) return;
    var rows = Array.from(guide.children).filter(function (node) { return node.tagName === 'P'; }).map(function (node) {
      var clean = node.textContent.replace(/[“”"]/g, '').replace(/chest\s*(?:to\s*)?fit/ig, '').replace(/\s+/g, ' ').trim();
      var match = clean.match(/^(XS|S|M|L|XL|XXL|XXXL|SMALL|MEDIUM|LARGE|X LARGE|XX LARGE)\s*[.\-:–]?\s*(\d+(?:\.\d+)?(?:\s*(?:cm|inches?))?)\s*$/i);
      return match ? {node: node, size: match[1], value: match[2]} : null;
    }).filter(Boolean);
    if (rows.length < 2) return;
    var table = document.createElement('table'); var header = table.createTHead().insertRow();
    [slot.dataset.sizeLabel, slot.dataset.chestLabel].forEach(function (label) { var th = document.createElement('th'); th.scope = 'col'; th.textContent = label; header.appendChild(th); });
    var body = table.createTBody(); rows.forEach(function (row) { var tr = body.insertRow(); tr.insertCell().textContent = row.size; tr.insertCell().textContent = row.value; });
    rows[0].node.before(table); rows.forEach(function (row) { row.node.remove(); });
  });
  Array.from(description.querySelectorAll('table')).concat(Array.from(slot.querySelectorAll('table'))).forEach(function (table) {
    var region = table.parentElement;
    if (!region.classList.contains('lif-size-table') && !region.classList.contains('lif-rte-table')) {
      region = document.createElement('div');
      table.before(region);
      region.appendChild(table);
    }
    region.classList.add('lif-rte-table');
    region.setAttribute('role', 'region');
    region.setAttribute('aria-label', slot.dataset.tableLabel);
    region.tabIndex = 0;
    var hint = document.createElement('p');
    hint.className = 'lif-table-hint';
    hint.textContent = slot.dataset.scrollHint;
    hint.hidden = true;
    region.after(hint);
    regions.push({region: region, hint: hint});
  });
  function updateHints() {
    regions.forEach(function (entry) { entry.hint.hidden = entry.region.scrollWidth <= entry.region.clientWidth + 1; });
  }
  var guide = slot.querySelector('.lif-size-guide');
  if (guide) {
    slot.hidden = false;
    guide.id = 'LifProductSizeGuide';
    Array.from(document.querySelectorAll('[data-size-guide-link]')).forEach(function (button) {
      button.hidden = false;
      button.setAttribute('aria-controls', guide.id);
      button.setAttribute('aria-expanded', String(guide.open));
      button.addEventListener('click', function () {
        guide.open = true;
        var summary = guide.querySelector('summary');
        if (summary) summary.focus({preventScroll: true});
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        guide.scrollIntoView({behavior: reduced ? 'instant' : 'smooth', block: 'start'});
      });
    });
    Array.from(slot.querySelectorAll('details')).forEach(function (details) {
      details.addEventListener('toggle', function () {
        document.querySelectorAll('[data-size-guide-link]').forEach(function (button) { button.setAttribute('aria-expanded', String(guide.open)); });
        updateHints();
      });
    });
  }
  if (!description.textContent.trim() && !description.querySelector('img,video,iframe')) {
    description.hidden = true;
    var emptyPanel = description.closest('[data-product-details]');
    if (emptyPanel) emptyPanel.hidden = true;
  }
  var descriptionPanel = description.closest('[data-product-details]');
  if (descriptionPanel) descriptionPanel.addEventListener('toggle', updateHints);
  window.addEventListener('resize', updateHints, {passive: true});
  if ('ResizeObserver' in window) {
    var observer = new ResizeObserver(updateHints);
    regions.forEach(function (entry) { observer.observe(entry.region); });
  }
  updateHints();
})();
